/**
 * Admit ordinary calls together; root transactions fence earlier and later calls (FIFO). One per
 * connection: the worker host, the main-thread proxy and the shared Turso adapter each own one.
 */
export function createWorkerSqlQueue(): <T>(run: () => Promise<T>, exclusive?: boolean) => Promise<T> {
  let barrier: Promise<unknown> = Promise.resolve()
  const pending = new Set<Promise<unknown>>()
  return <T>(run: () => Promise<T>, exclusive = false): Promise<T> => {
    const prior = exclusive ? Promise.all([barrier, ...pending]) : barrier
    const next = prior.then(run, run)
    const settled = next.then(() => null, () => null)
    pending.add(settled)
    void settled.then(() => pending.delete(settled))
    if (exclusive) barrier = settled
    return next
  }
}
